import CompanyModel from '@/views/company/model/CompanyModel'
export default class companyViewModel {
  constructor() {
    this.model = new CompanyModel();
    this.isMobile = false;
  }
}